// 购物车相关接口
import request from '@/utils/http';

/**
 * 查询购物车列表
 * @param params
 * @returns {Promise<AxiosResponse>}
 */
export function queryCartList(params) {
  return request.get('/mall/cart/findCart', { params });
}

/**
 * 新增购物车
 * @param data
 * @data {
 *  skuId: 商品id,
 *  spuId: 商品spuId,
 *  count: 商品数量,
 * }
 * @returns {Promise<AxiosResponse>}
 */
export function addCart(data) {
  return request.post('/mall/cart/saveCart', data);
}

/**
 * 根据购物车id删除购物车
 * @param params
 * @returns {Promise<AxiosResponse>}
 */
export function deleteCart(cartId) {
  return request.delete('/mall/cart/deleteCartById?cartId=' + cartId);
}

/**
 * 清空购物车
 * @param params
 * @returns {Promise<AxiosResponse>}
 */
export function clearCart() {
  return request.delete('/mall/cart/deleteAllCart');
}

/**
 * 更新购物车状态
 * @param params
 * @params {
 *  cartId: 购物车id,
 *  type: 选择单个2 还是全部 1,
 *  status: 选择状态 1 还是 0,
 * }
 * @returns {Promise<AxiosResponse>}
 */
export function updateCartSelect(data) {
  return request.post('/mall/cart/updateCartSelect', data);
}
/**
 * 更新购物车商品数量
 * @param params
 * @params {
 *  cartId: 购物车id,
 * count: 商品数量,
 * }
 * @returns {Promise<AxiosResponse>}
 */
export function updateCartProductCount(data) {
  return request.post('/mall/cart/updateCartProductCount', data);
}